export default __webpack_public_path__ + "static/media/screen_livechat_15.29996087.png";